import React from 'react';
import { PMAX_LITE_WIZARD_STEP_PATHS } from '@bingads-webui-campaign-react/pmax-lite-wizard-utils';
import { DelayedAccountDetailsStepWithI18n } from './delayed-account-details';

export const AccountDetailsStepConfig = {
  id: PMAX_LITE_WIZARD_STEP_PATHS.ACCOUNT_DETAILS,
  render: () => <DelayedAccountDetailsStepWithI18n />,
};

export const PreviewAccountStepConfig = {
  id: PMAX_LITE_WIZARD_STEP_PATHS.PREVIEW_ACCOUNT,
  render: () => <DelayedAccountDetailsStepWithI18n />,
};
